import React from "react";
import { useEffect, useState } from "react";
import styled from "styled-components";
import indiecita from "../../src/img/indiecita.png";
import cornetas from "../../src/img/top_con_cornetas.png";
import premios from "../../src/img/premios_trivia.png";
import axios from "axios";
import cerrar from "../../src/img/cerrar.png";
import signoDePregunta from "../../src/img/signodepregunta.png";
import fondoTrivia from "../../src/img/fondo_trivia.png";
import $ from "jquery";

const Trivia = ({
  viewTrivia,
  setviewTrivia,
  viewConfirmacion,
  setviewConfirmacion,
  documento,
  token,
  size,
  viewBases,
  setviewBases,
}) => {
  const [opc1bFondo, setopc1bFondo] = useState("#ffffff");
  const [opc1bLetra, setopc1bLetra] = useState("#217bbe");
  const [opc1aFondo, setopc1aFondo] = useState("#ffffff");
  const [opc1aLetra, setopc1aLetra] = useState("#217bbe");
  const [opc2aFondo, setopc2aFondo] = useState("#ffffff");
  const [opc2aLetra, setopc2aLetra] = useState("#217bbe");
  const [opc2bFondo, setopc2bFondo] = useState("#ffffff");
  const [opc2bLetra, setopc2bLetra] = useState("#217bbe");
  const [opc3aFondo, setopc3aFondo] = useState("#ffffff");
  const [opc3aLetra, setopc3aLetra] = useState("#217bbe");
  const [opc3bFondo, setopc3bFondo] = useState("#ffffff");
  const [opc3bLetra, setopc3bLetra] = useState("#217bbe");
  const [triviaRespuesta1, settriviaRespuesta1] = useState("");
  const [triviaRespuesta2, settriviaRespuesta2] = useState("");
  const [triviaRespuesta3, settriviaRespuesta3] = useState("");
  const [checkBases, setcheckBases] = useState(false);
            //setviewConfirmacion(true);

  const alertaError = (mensaje) => {
    $.confirm({
      title: '<b className="op-text">Trivia</b>',
      backgroundDismiss: true,
      columnClass: "medium",
      animation: "zoom",
      closeIcon: true,
      closeAnimation: "scale",
      content: `<h5 className="text-center mt-4 mb-2">
          ${mensaje}
					 </h5>`,
      buttons: {
        Si: {
          text: "Aceptar",
          action: function () {},
        },
      },
    });
  };

  const handleClickParticipar = () => {
    let url =
      process.env.REACT_APP_URL_BASE_BACKEND +
      process.env.REACT_APP_WS_INIT_TRIVIA;

    if (
      triviaRespuesta1 === "" ||
      triviaRespuesta2 === "" ||
      triviaRespuesta3 === ""
    ) {
      alertaError("Por favor, complete todas las respuestas");
    } else {
      axios
        .post(
          url,
          {
            documentoUsuario: documento,
            respuesta1: triviaRespuesta1,
            respuesta2: triviaRespuesta2,
            respuesta3: triviaRespuesta3,
          },
          {
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              Authorization: "Bearer " + token,
            },
          }
        )
        .then((res) => {
          if (res.status === 200) {
            cerrarTrivia();
            setviewConfirmacion(true);
          }
          return res.data;
        })
        .catch((err) => {
          console.error(err);
          alertaError("Ha habido un error intentelo nuevamente");
        });
    }
  };

  const clickCheckbox = () => {
    setcheckBases(!checkBases);
  };

  const clickBoton = (valor) => {
    switch (valor) {
      case "botonopc1a":
        setopc1aFondo("#0c4fa3");
        setopc1aLetra("#ffffff");
        setopc1bFondo("#ffffff");
        setopc1bLetra("#217bbe");
        settriviaRespuesta1("Francia");
        break;
      case "botonopc2a":
        setopc2aFondo("#0c4fa3");
        setopc2aLetra("#ffffff");
        setopc2bFondo("#ffffff");
        setopc2bLetra("#217bbe");
        settriviaRespuesta2("Uruguay");
        break;
      case "botonopc1b":
        setopc1bFondo("#0c4fa3");
        setopc1bLetra("#ffffff");
        setopc1aFondo("#ffffff");
        setopc1aLetra("#217bbe");
        settriviaRespuesta1("Italia");
        break;
      case "botonopc2b":
        setopc2bFondo("#0c4fa3");
        setopc2bLetra("#ffffff");
        setopc2aFondo("#ffffff");
        setopc2aLetra("#217bbe");
        settriviaRespuesta2("Inglaterra");
        break;
      case "botonopc3a":
        setopc3aFondo("#0c4fa3");
        setopc3aLetra("#ffffff");
        setopc3bFondo("#ffffff");
        setopc3bLetra("#217bbe");
        settriviaRespuesta3("DiMaria");
        break;
      case "botonopc3b":
        setopc3bFondo("#0c4fa3");
        setopc3bLetra("#ffffff");
        setopc3aFondo("#ffffff");
        setopc3aLetra("#217bbe");
        settriviaRespuesta3("DePaul");
        break;
      case "cerrar":
        settriviaRespuesta1("");
        settriviaRespuesta2("");
        settriviaRespuesta3("");
        setviewTrivia(false);
        break;
      case "bases":
        setviewBases(true);
        setviewTrivia(false);
        settriviaRespuesta1("");
        settriviaRespuesta2("");
        settriviaRespuesta3("");
        break;
      default:
    }
  };

  const cerrarTrivia = () => {
    setviewTrivia(false);
  };

  return (
    <DivGralCard>
      <div className="container">
        <div className="row">
          <div className="col">
            <DivCard
              size={size}
              className="card text-center animate__animated animate__fadeInDownBig"
            >
              <div className="card-header" style={{ color: "#ffffff" }}>
                <DivCerrar className="btn" id="btnCerrar">
                  <img
                    src={cerrar}
                    alt="cerrar"
                    id="cerrar"
                    onClick={(e) => clickBoton(e.target.id)}
                  />
                </DivCerrar>
                <img src={cornetas} alt="cornetas" style={{ width: "230px", marginTop: "10px" }} />
              </div>
              <div className="card-body" style={{ color: "#ffffff"}}>
                <ImgIndiecita src={indiecita} alt="indiecita" />
                <div className="container">
                  <div className="row mb-1">
                    <div className="col-10 text-left">¿Qué país ganó<br></br> 4 copas del mundo?</div>
                  </div>
                  <div className="row mb-1">
                    <BotonTrivia
                      fondo={opc1aFondo}
                      fontColor={opc1aLetra}
                      type="button"
                      className="btn mr-1"
                      id="botonopc1a"
                      onClick={(e) => clickBoton(e.target.id)}
                    >
                      Francia
                    </BotonTrivia>
                    <BotonTrivia
                      fondo={opc1bFondo}
                      fontColor={opc1bLetra}
                      type="button"
                      className="btn"
                      id="botonopc1b"
                      onClick={(e) => clickBoton(e.target.id)}
                    >
                      Italia
                    </BotonTrivia>
                  </div>
                  <div className="row mb-1">
                    <div className="col-10 text-left">
                      ¿Quién ganó el primer <br></br>mundial (1930)?
                    </div>
                  </div>
                  <div className="row mb-1">
                    <BotonTrivia
                      fondo={opc2aFondo}
                      fontColor={opc2aLetra}
                      type="button"
                      className="btn mr-1"
                      id="botonopc2a"
                      onClick={(e) => clickBoton(e.target.id)}
                    >
                      Uruguay
                    </BotonTrivia>
                    <BotonTrivia
                      fondo={opc2bFondo}
                      fontColor={opc2bLetra}
                      type="button"
                      className="btn"
                      id="botonopc2b"
                      onClick={(e) => clickBoton(e.target.id)}
                    >
                      Inglaterra
                    </BotonTrivia>
                  </div>
                  <div className="row mb-1">
                    <div className="col-10 text-left">
                      ¿Qué otro jugador, además de Messi, hizo un gol en la final de Qatar 2022?
                    </div>
                  </div>
                  <div className="row mb-1">
                    <BotonTrivia
                      fondo={opc3aFondo}
                      fontColor={opc3aLetra}
                      type="button"
                      className="btn mr-1"
                      id="botonopc3a"
                      onClick={(e) => clickBoton(e.target.id)}
                    >
                      Di María
                    </BotonTrivia>
                    <BotonTrivia
                      fondo={opc3bFondo}
                      fontColor={opc3bLetra}
                      type="button"
                      className="btn"
                      id="botonopc3b"
                      onClick={(e) => clickBoton(e.target.id)}
                    >
                      De Paul
                    </BotonTrivia>
                  </div>
                  <div className="form-check text-left">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id="checkBases"
                      onClick={() => clickCheckbox()}
                    />
                    <label
                      className="form-check-label"
                      for="checkBases"
                      id="bases"
                      onClick={(e) => clickBoton(e.target.id)}
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        color: "darkmagenta",
                      }}
                    >
                      Bases y condiciones
                    </label>
                  </div>
                </div>

                <ButtonParticipar
                  onClick={() => handleClickParticipar()}
                  className="btn"
                  id="botonParticipar"
                  disabled={!checkBases}
                >
                  ¡PARTICIPAR!
                </ButtonParticipar>
              </div>
            </DivCard>
          </div>
        </div>
      </div>
    </DivGralCard>
  );
};

export default Trivia;

const DivCard = styled.div`
  top: ${(props) => (props.size <= 991 ? "6%" : "6%")};
  min-width: 40vh;
  min-height: 71vh;
  max-width: 61vh;
  background-color: #217bbe;
  background-image: url(${fondoTrivia});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  overflow: hidden;
  border-radius: 10px;
  margin-left: auto;
  margin-right: auto;
`;
const ButtonParticipar = styled.button`
  margin-top: 4vh;
  min-width: 7em;
  border-radius: 5px !important;
  background-color: #009541;
  color: #ffffff;
  border: 1px solid #ffffff;
  &:disabled {
    background-color: #ffffff;
    color: #009541;
    border: 1px solid #ffffff;
    opacity: 1;
  }
`;
const DivGralCard = styled.div`
  width: 100%;
  height: 100vh;
  background-color: #0000005e;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 3 !important;
`;

const BotonTrivia = styled.button`
  width: 7em;
  font-size: 2vh;
  background-color: ${(props) => props.fondo};
  color: ${(props) => props.fontColor};
  border-radius: 5px !important;
`;
const ImgIndiecita = styled.img`
  z-index: -2 !important;
  position: fixed;
  height: 68%;
  right: 0vh;
`;

const DivCerrar = styled.div`
  position: fixed;
  right: 1vh;
`;


